<app-city-selector
  *ngIf="canShowCitySelector()"
  [class.hidden-spacer]="true"
  [class.both]="!canShowCitySearch()"
>
</app-city-selector>
<app-selectfilter
  *ngIf="selectedPOILabel || (poiList && poiList.length)"
  [title]="('Search a place' | translate) + '...'"
  [items]="poiList"
  [value]="selectedPOILabel"
  [attr.style]="brandIcon"
  (changeValue)="onPOISelected($event)"
>
</app-selectfilter>
